export enum PackagesTypeId {
  Confort = 1,
  ConfortPlus = 2,
}
